import { useEffect, useState } from "react";
import { resolveMediaUrl } from "../../lib/utils";

const KEY = "lumora_brand";
export const saveBrand = (settings) => {
  if (!settings) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ name: settings.restaurant_name || "", logo: settings.logo_url || "", color: settings.primary_color || "" }));
  } catch { /* storage cheio */ }
};
export const loadBrand = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};

// Ecrã de boas-vindas no arranque da app com o logótipo/nome da empresa (uma vez por sessão do browser/app)
export const WelcomeSplash = ({ user }) => {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem("lumora_splash_shown"));
  const [fade, setFade] = useState(false);
  const brand = loadBrand();

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem("lumora_splash_shown", "1");
    const t1 = setTimeout(() => setFade(true), 1400);
    const t2 = setTimeout(() => setVisible(false), 1900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;
  const logo = brand?.logo ? resolveMediaUrl(brand.logo) : "/lumora-logo.png";
  const name = brand?.name || "Lumora";
  const hour = new Date().getHours();
  const greet = hour < 12 ? "Bom dia" : hour < 19 ? "Boa tarde" : "Boa noite";
  return (
    <div className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0A0A] text-white transition-opacity duration-500 ${fade ? "opacity-0 pointer-events-none" : "opacity-100"}`} data-testid="welcome-splash" aria-hidden={fade}>
      <div className="pointer-events-none absolute -top-40 -right-32 h-[500px] w-[500px] rounded-full bg-cyan-500/10 blur-[130px]" />
      <div className="pointer-events-none absolute -bottom-40 -left-32 h-[420px] w-[420px] rounded-full bg-blue-600/10 blur-[130px]" />
      <div className="relative flex flex-col items-center animate-fade-in">
        <div className="h-28 w-28 rounded-3xl bg-white/95 p-3 shadow-2xl shadow-cyan-500/20 flex items-center justify-center overflow-hidden">
          <img src={logo} alt={name} className="max-h-full max-w-full object-contain" data-testid="welcome-splash-logo" onError={(e) => { e.currentTarget.src = "/lumora-logo.png"; }} />
        </div>
        <h1 className="mt-6 text-2xl sm:text-3xl font-extrabold tracking-tight text-center" data-testid="welcome-splash-name">{name}</h1>
        <p className="mt-2 text-sm text-zinc-400" data-testid="welcome-splash-greeting">{greet}{user?.name ? `, ${user.name.split(" ")[0]}` : ""} — a preparar o seu espaço de trabalho…</p>
        <div className="mt-6 h-1 w-40 overflow-hidden rounded-full bg-white/10"><div className="h-full w-1/2 rounded-full bg-cyan-400 animate-[splashbar_1.4s_ease-in-out_infinite]" /></div>
        {brand?.name && <p className="mt-8 text-[11px] uppercase tracking-[0.3em] text-zinc-500">Powered by Lumora</p>}
      </div>
      <style>{`@keyframes splashbar { 0% { transform: translateX(-100%); } 100% { transform: translateX(300%); } }`}</style>
    </div>
  );
};
